// extracted by mini-css-extract-plugin
export default {"checkout":"checkout_checkout__iAlCC","checkout__price":"checkout_checkout__price__gQ4sx"};